module.exports = __webpack_public_path__ + "0bcb0d8a7f2c0be3a79b56b2d7fbf3e6.svg";